import { tryAxios } from '@/api/common/auth'
import { urlPrefix } from '@/configs/api'
const apiUrl = `${urlPrefix}/UnitProject`
//#region 基本信息
const GetList = (id: number) => `${apiUrl}/GetList/${id}`
const GetImplements = (id: number) => `${apiUrl}/implements/${id}`
const GetImplement = (id: number) => `${apiUrl}/implement/${id}`
const GetInfo = (id: number) => `${apiUrl}/${id}`
const ViewInfo = (id: number) => `${apiUrl}/view/${id}`
const PostData = `${apiUrl}`
const PutData = (id: number) => `${apiUrl}/${id}`
const Delete = (id: number) => `${apiUrl}/${id}`
//#endregion

export const emptyData: UnitProjectData = {
    Id: 0,
    UnitId: 0,
    ProjectName: '',
    PropertiesId: 0,
    LxName: '',
    LxYear: 0,
    LxMonth: 0,
    DocId: 0,
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),

    PropertiesName: '',
    DocNo: '',
    UserName: '',
    ImplementList: []
}
export interface UnitProjectData {
    [key: string]: any
    DocId: number
    Id: number
    LxName: string
    LxMonth: number
    LxYear: number
    NewDate: Date
    NewUserId: number
    ProjectName: string
    PropertiesId: number
    Status: number
    UnitId: number
    UpdateDate: Date
    UpdateUserId: number

    PropertiesName: string
    DocNo: string
    UserName: string
    ImplementList: UnitProjectImplementData[]
}

export const emptyImplement: UnitProjectImplementData = {
    Id: 0,
    UnitProjectId: 0,
    ProposalName: '',
    ProposalBeginYear: 0,
    ProposalBeginMonth: 0,
    ProposalDocId: 0,
    ProposalPhase: 0,
    ProposalDesignUnit: '',
    ProposalNationFund: 0,
    ProposalProvinceFund: 0,
    ProposalPlaceFund: 0,
    ProjectNationFund: 0,
    ProjectProvinceFund: 0,
    ProjectPlaceFund: 0,
    ProjectName: '',
    ProjectPhaseId: 0,
    ProjectDesignUnit: '',
    ProjectConstructionUnit: '',
    ProjectSuperviseUnit: '',
    ProjectStartYear: 0,
    ProjectStartMonth: 0,
    ProjectEndYear: 0,
    ProjectEndMonth: 0,
    ProjectProgressSpecification: '',
    ProjectProgressPercent: 0,
    ProjectAcceptanceYear: 0,
    ProjectAcceptanceMonth: 0,
    ProjectAcceptanceResult: '',
    UnitHistoryRepairSpecification: '',
    ProposalOpinions: '',
    ProjectCheckResult: '',
    ProjectCheckYear: 0,
    ProjectCheckMonth: 0,
    Status: 0,
    NewUserId: 0,
    NewDate: new Date(),
    UpdateUserId: 0,
    UpdateDate: new Date(),


    ProposalDocNo: '',
    UserName: '',
    ProposalPhaseName: '',
    ProjectPhaseName: '',

    AttachTypePhoto: 0,
    AttachGuidPhoto: '',
    AttachTypePlan: 0,
    AttachGuidPlan: '',
    AttachTypeOpinion: 0,
    AttachGuidOpinion: '',
    AttachTypeScheme: 0,
    AttachGuidScheme: ''
}
export interface UnitProjectImplementData {
    [key: string]: any
    Id: number
    UnitProjectId: number
    ProposalName: string
    ProposalBeginYear: number
    ProposalBeginMonth: number
    ProposalDocId: number
    ProposalPhase: number
    ProposalDesignUnit: string
    ProposalNationFund: number
    ProposalProvinceFund: number
    ProposalPlaceFund: number
    ProjectNationFund: number
    ProjectProvinceFund: number
    ProjectPlaceFund: number
    ProjectName: string
    ProjectPhaseId: number
    ProjectDesignUnit: string
    ProjectConstructionUnit: string
    ProjectSuperviseUnit: string
    ProjectStartYear: number
    ProjectStartMonth: number
    ProjectEndYear: number
    ProjectEndMonth: number
    ProjectProgressSpecification: string
    ProjectProgressPercent: number
    ProjectAcceptanceYear: number
    ProjectAcceptanceMonth: number
    ProjectAcceptanceResult: string
    UnitHistoryRepairSpecification: string
    ProposalOpinions: string
    ProjectCheckResult: string
    ProjectCheckYear: number
    ProjectCheckMonth: number
    Status: number
    NewUserId: number
    NewDate: Date
    UpdateUserId: number
    UpdateDate: Date

    ProposalDocNo: string
    UserName: string
    ProposalPhaseName: string
    ProjectPhaseName: string

    AttachTypePhoto: number
    AttachGuidPhoto: string
    AttachTypePlan: number
    AttachGuidPlan: string
    AttachTypeOpinion: number
    AttachGuidOpinion: string
    AttachTypeScheme: number
    AttachGuidScheme: string
}
export const removeData = (id: number) => {
    return tryAxios({
        method: 'delete',
        url: Delete(id)
    })
}
export const getList = (unitId: number) => {
    return tryAxios({
        method: 'get',
        url: GetList(unitId),
    })
}
export const getImplements = (unitProjectId: number) => {
    return tryAxios({
        method: 'get',
        url: GetImplements(unitProjectId),
    })
}
export const getInfo = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetInfo(id),
    })
}
export const getImplement = (id: number) => {
    return tryAxios({
        method: 'get',
        url: GetImplement(id),
    })
}
// export const viewInfo = (id: number) => {
//     return tryAxios({
//         method: 'get',
//         url: ViewInfo(id),
//     })
// }
export const postData = (form: UnitProjectData) => {
    return tryAxios({
        method: 'post',
        url: PostData,
        data: form
    })
}
export const putData = (id: number, form: UnitProjectData) => {
    return tryAxios({
        method: 'put',
        url: PutData(id),
        data: form
    })
}
